import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const PaymentTypes = () => {
    document.title = "Ödəniş növləri";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Ödəniş növləri", value: "/cash/paymenttypes", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Ödəniş növləri</h2>
                    <p>
                        Kassa proqramında icra olunan satışlardan əldə olunan pul vəsaitlərini qeyd etmək üçün nəzərdə tutulub. Ödənişlər dörd formada qəbul
                        edilə bilər
                        <ol>
                            <li>
                                Nəğd olaraq alınan pul vəsaitləri <b>Nəğd ödənişlər</b> seçimi edilərək qeyd olunur
                            </li>
                            <li>
                                Kart ilə ödənilən ödənişi qeyd etmək üçün <b>Kart ilə ödənişlər</b> seçimini edib məbləği yazmalı və <SaveButton /> düyməsini
                                sıxmaq lazımdır
                            </li>
                            <li>
                                Müştəri seçimi edildikdən sonra aktiv olan <b>Bonus ödənişləri</b>, ödənişin bonus balansından silinməsi üçün nəzərdə tutulub
                            </li>
                            <li>
                                Müştəri seçimi edildikdən sonra aktiv olan <b>Borc</b> seçimi, satışın nisyə ( borca ) satıldığını qeyd etmək üçün nəzərdə
                                tutulub
                            </li>
                        </ol>
                        <b>Qeyd</b>: bütün hallarda satış əməliyyatını yekunlaşdırmaq üçün <SaveButton>Ümumi məbləğ</SaveButton> düyməsini sıxmaq lazımdır
                    </p>
                    <img src="/images/cash/paymenttypes.gif" alt="Ödəniş növləri" />
                </article>
            </div>
        </div>
    );
};
